import { SUPPORT_ERROR_MESSAGE } from '@/constants';

export const extractErrorMessageFromUnknownError = (error: unknown): string => {
  const errorMessage =
    error && typeof error === 'object' && 'message' in error && typeof error.message === 'string'
      ? error.message
      : SUPPORT_ERROR_MESSAGE;

  return errorMessage;
};
